import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  InputGroup,
  Row,
  Form,
  Modal,
} from "react-bootstrap";
import { base_url, postHeader, client_name } from "../../../../../../Helpers/request";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../../../../Components/Loader";
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';

export const Newsletter = () => {
  const history = useHistory();
  const currencycode = useSelector(
    (state) => state.persistedReducer.home.currencycode
  );
  const [newsletteremail, setNewsletteremail] = useState("");
  const [loader, setLoader] = useState(false);
  const newsletter = (e) => {
    e.preventDefault();
    setLoader(true);
    const data = {
      currency_code: currencycode,
      email: newsletteremail,
    };
    axios
      .post(base_url + "/common/subscribe_newsletter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setNewsletteremail("");
          return swal(res.data.message, "", "success");
        } else {
          setLoader(false);
          return swal(res.data.message, "", "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };


  
  return (
    <>
      <section className='signup_section'  id="newsletter">
        <div className='container text-center'>
          <Row className="d-flex align-items-center">
            <Col sm={12} md={6}>
          <h3 className='mb-3 text-lg-left'>Stay In Touch</h3>
          <p className='text-lg-left'>Become a preferred subscriber and get a special offer on your purchase.</p>
            </Col>
           <Col sm={12} md={6} className="text-right">
          <div className='form'>
            <form onSubmit={newsletter}>
              <InputGroup className='justify-content-end'>
                <Form.Control
                  placeholder="EMAIL ADDRESS"
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                  type="email"
                  value={newsletteremail}
                  required
                  onChange={(e) => setNewsletteremail(e.target.value)}
                  />
                <Button variant="outline-secondary" type="submit"
                  id="button-addon2" className="mt-3 mt-sm-0">SUBSCRIBE</Button>
              </InputGroup>
            </form>
          </div>
           </Col>
                  </Row>
          {/* <p className='desc-dark'>By signing up you confirm that you have read the <Link to="/privacy-policy" className='text-dark'><strong>Privacy Policy</strong></Link> and agree that your email will be collected and used for the purposes of sending news, promotions and updates via email. You can withdraw your consent at any time by unsubscribing.</p> */}
        </div>
        <Modal show={loader}>
          <Loader />
        </Modal>
      </section>
    </>
  )
};
